exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editor-wrapper label {\n  color: #8e8787;\n  margin-bottom: 30px;\n}\n.editor-wrapper .ql-editor {\n  min-height: 18rem;\n  max-height: 18rem;\n}\n.editor-wrapper .quillWrapper {\n  color: #8e8787;\n}\n.editor-wrapper .validation-error,\n.editor-wrapper .error-message {\n  color: var(--v-error-base);\n}\n.editor-wrapper .error-message {\n  padding: 0.5rem 0;\n  font-size: 12px;\n}\n.disabled-editor .ql-snow.ql-toolbar {\n  display: none;\n}\n.disabled-editor #quill-container {\n  border-top: 1px solid #ccc;\n  background: rgba(0,0,0,0.038);\n  border-radius: 2px;\n}\n", ""]);

// exports
